import React, { forwardRef } from 'react';
import { Select as SelectBase, SelectProps } from "@chakra-ui/core";

import { Container, Label } from './styles';

interface Props extends SelectProps {
  label?: string;
  error?: any;
  borderColor?: string;
  name: string;
  options?: { value: string; label: string }[];
}

const SearchSelect: React.FC<Props> = forwardRef(({ name, label, error, options, borderColor, ...props }, ref) => {

  return (
    <Container>
      <Label>{label}</Label>
      <SelectBase {...props} name={name} borderRadius="6px" borderColor="#01509C" height="36px" fontSize={14} ref={ref}>
        {options?.map(o =>
          <option key={o.value} value={o.value}>{o.label}</option>
        )}
      </SelectBase>
    </Container>
  );
});

export default SearchSelect;
